/* eslint-disable react/style-prop-object */
import React from 'react';

const IconAiPen = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2896_63020)">
      <path
        d="M4.09364 18C5.31089 17.3922 6.29848 16.4046 6.90625 15.1874C7.51402 16.4046 8.50161 17.3922 9.71886 18C8.50161 18.6078 7.51402 19.5954 6.90625 20.8126C6.29848 19.5954 5.31089 18.6078 4.09364 18Z"
        stroke="url(#paint0_linear_2896_63020)"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <path
        d="M5.05344 10.0991L5.12344 10.2891C5.38344 10.9791 5.92344 11.5291 6.62344 11.7891L6.81344 11.8591C6.95344 11.9091 6.95344 12.0991 6.81344 12.1491L6.62344 12.2191C5.93344 12.4791 5.38344 13.0191 5.12344 13.7191L5.05344 13.9091C5.00344 14.0491 4.81344 14.0491 4.76344 13.9091L4.69344 13.7191C4.43344 13.0291 3.89344 12.4791 3.19344 12.2191L3.00344 12.1491C2.86344 12.0991 2.86344 11.9091 3.00344 11.8591L3.19344 11.7891C3.88344 11.5291 4.43344 10.9891 4.69344 10.2891L4.76344 10.0991C4.81344 9.95914 5.00344 9.95914 5.05344 10.0991Z"
        fill="url(#paint1_linear_2896_63020)"
      />
      <path
        d="M17.8456 19.9393C18.4314 20.5251 19.3811 20.5251 19.9669 19.9393L20.8456 19.0607C21.4314 18.4749 21.4314 17.5251 20.8456 16.9393L11.9669 8.06066C11.3811 7.47487 10.4314 7.47487 9.84559 8.06066L8.96691 8.93934C8.38112 9.52513 8.38112 10.4749 8.96691 11.0607L17.8456 19.9393Z"
        stroke="url(#paint2_linear_2896_63020)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9062 13L13.9062 10"
        stroke="url(#paint3_linear_2896_63020)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 6.72C6.875 4.98 8.745 3.71 10.905 3.22C11.545 3.08 12.215 3 12.905 3C15.385 3 17.645 4.01 19.265 5.64C20.895 7.26 21.905 9.52 21.905 12"
        stroke="url(#paint4_linear_2896_63020)"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2896_63020"
        x1={10.8547}
        y1={20.3221}
        x2={2.74394}
        y2={20.0265}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0070D1" />
        <stop offset={0.0625} stopColor="#0070D1" />
        <stop offset={0.125} stopColor="#0271D2" />
        <stop offset={0.1875} stopColor="#0473D3" />
        <stop offset={0.25} stopColor="#0775D4" />
        <stop offset={0.3125} stopColor="#0B78D5" />
        <stop offset={0.375} stopColor="#107BD7" />
        <stop offset={0.4375} stopColor="#1680DA" />
        <stop offset={0.5} stopColor="#1D84DD" />
        <stop offset={0.5625} stopColor="#258AE0" />
        <stop offset={0.625} stopColor="#2D90E3" />
        <stop offset={0.6875} stopColor="#3796E7" />
        <stop offset={0.75} stopColor="#419EEB" />
        <stop offset={0.8125} stopColor="#4DA5EF" />
        <stop offset={0.875} stopColor="#59AEF4" />
        <stop offset={0.9375} stopColor="#66B7F9" />
        <stop offset={1} stopColor="#74C1FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2896_63020"
        x1={6.89253}
        y1={13.171}
        x2={2.81688}
        y2={13.0225}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0070D1" />
        <stop offset={0.0625} stopColor="#0070D1" />
        <stop offset={0.125} stopColor="#0271D2" />
        <stop offset={0.1875} stopColor="#0473D3" />
        <stop offset={0.25} stopColor="#0775D4" />
        <stop offset={0.3125} stopColor="#0B78D5" />
        <stop offset={0.375} stopColor="#107BD7" />
        <stop offset={0.4375} stopColor="#1680DA" />
        <stop offset={0.5} stopColor="#1D84DD" />
        <stop offset={0.5625} stopColor="#258AE0" />
        <stop offset={0.625} stopColor="#2D90E3" />
        <stop offset={0.6875} stopColor="#3796E7" />
        <stop offset={0.75} stopColor="#419EEB" />
        <stop offset={0.8125} stopColor="#4DA5EF" />
        <stop offset={0.875} stopColor="#59AEF4" />
        <stop offset={0.9375} stopColor="#66B7F9" />
        <stop offset={1} stopColor="#74C1FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2896_63020"
        x1={21.816}
        y1={18.0637}
        x2={7.6222}
        y2={17.5464}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0070D1" />
        <stop offset={0.0625} stopColor="#0070D1" />
        <stop offset={0.125} stopColor="#0271D2" />
        <stop offset={0.1875} stopColor="#0473D3" />
        <stop offset={0.25} stopColor="#0775D4" />
        <stop offset={0.3125} stopColor="#0B78D5" />
        <stop offset={0.375} stopColor="#107BD7" />
        <stop offset={0.4375} stopColor="#1680DA" />
        <stop offset={0.5} stopColor="#1D84DD" />
        <stop offset={0.5625} stopColor="#258AE0" />
        <stop offset={0.625} stopColor="#2D90E3" />
        <stop offset={0.6875} stopColor="#3796E7" />
        <stop offset={0.75} stopColor="#419EEB" />
        <stop offset={0.8125} stopColor="#4DA5EF" />
        <stop offset={0.875} stopColor="#59AEF4" />
        <stop offset={0.9375} stopColor="#66B7F9" />
        <stop offset={1} stopColor="#74C1FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2896_63020"
        x1={13.8869}
        y1={12.3708}
        x2={10.8454}
        y2={12.2599}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0070D1" />
        <stop offset={0.0625} stopColor="#0070D1" />
        <stop offset={0.125} stopColor="#0271D2" />
        <stop offset={0.1875} stopColor="#0473D3" />
        <stop offset={0.25} stopColor="#0775D4" />
        <stop offset={0.3125} stopColor="#0B78D5" />
        <stop offset={0.375} stopColor="#107BD7" />
        <stop offset={0.4375} stopColor="#1680DA" />
        <stop offset={0.5} stopColor="#1D84DD" />
        <stop offset={0.5625} stopColor="#258AE0" />
        <stop offset={0.625} stopColor="#2D90E3" />
        <stop offset={0.6875} stopColor="#3796E7" />
        <stop offset={0.75} stopColor="#419EEB" />
        <stop offset={0.8125} stopColor="#4DA5EF" />
        <stop offset={0.875} stopColor="#59AEF4" />
        <stop offset={0.9375} stopColor="#66B7F9" />
        <stop offset={1} stopColor="#74C1FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2896_63020"
        x1={21.8001}
        y1={10.1124}
        x2={5.34429}
        y2={9.02757}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0070D1" />
        <stop offset={0.0625} stopColor="#0070D1" />
        <stop offset={0.125} stopColor="#0271D2" />
        <stop offset={0.1875} stopColor="#0473D3" />
        <stop offset={0.25} stopColor="#0775D4" />
        <stop offset={0.3125} stopColor="#0B78D5" />
        <stop offset={0.375} stopColor="#107BD7" />
        <stop offset={0.4375} stopColor="#1680DA" />
        <stop offset={0.5} stopColor="#1D84DD" />
        <stop offset={0.5625} stopColor="#258AE0" />
        <stop offset={0.625} stopColor="#2D90E3" />
        <stop offset={0.6875} stopColor="#3796E7" />
        <stop offset={0.75} stopColor="#419EEB" />
        <stop offset={0.8125} stopColor="#4DA5EF" />
        <stop offset={0.875} stopColor="#59AEF4" />
        <stop offset={0.9375} stopColor="#66B7F9" />
        <stop offset={1} stopColor="#74C1FF" />
      </linearGradient>
      <clipPath id="clip0_2896_63020">
        <rect
          width={24}
          height={24}
          fill="white"
          transform="translate(0.90625)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default IconAiPen;
